import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import Field from '../../../fields'
import {
  ETHNICITIES,
  LANGUAGES,
  MARITAL_STATUSES,
  NATIONALITIES,
  RELIGIONS,
  SEXUAL_PREFERENCES,
} from '../../../../common/constants'

interface ResidentPersonalInfoProps {
  fields: any
  formId: string
  style: React.CSSProperties
}

/**
 * TO_DELETE
 */
export default class ResidentPersonalInfo extends React.Component<ResidentPersonalInfoProps> {
  render() {
    const { fields, formId, style } = this.props
    if (!fields) return null
    return (
      <div style={style}>
        <Suspense fallback={<div>Loading...</div>}>
        <Field
          className="address-field"
          keys="address"
          label="Address"
          formId={formId}
          type="address"
          values={fields}
        />
        </Suspense>
        <div style={{ paddingTop: 20 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            className="marital-status-field"
            keys="maritalStatus"
            label="Marital status"
            formId={formId}
            options={MARITAL_STATUSES}
            type="radios"
            values={fields}
          />
          </Suspense>
        </div>
        <div style={{ paddingTop: 20 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            keys="phoneNumber"
            label="Phone Number"
            formId={formId}
            values={fields}
            options={{
              phone: true,
              phoneRegionCode: 'GB',
            }}
            type="formattedText"
          />
          </Suspense>
        </div>
        <div style={{ paddingTop: 20 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            className="birthplace-field"
            keys="birthplace"
            label="Birthplace"
            formId={formId}
            type="text"
            values={fields}
          />
          </Suspense>
        </div>
        <div style={{ paddingTop: 20 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            keys="nationality"
            label="Nationality"
            formId={formId}
            options={NATIONALITIES}
            placeholders="Start typing here"
            type="select"
            values={fields}
          />
          </Suspense>
        </div>
        <div style={{ paddingTop: 20 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            className="languages-field"
            keys="languagesSpoken"
            label="Language(s) spoken"
            formId={formId}
            options={LANGUAGES}
            type="multiSelect"
            values={fields}
          />
          </Suspense>
        </div>
        <div style={{ paddingTop: 20 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            keys="ethnicity"
            label="Ethnicity"
            formId={formId}
            options={ETHNICITIES}
            placeholders="Choose from list"
            type="select"
            values={fields}
          />
          </Suspense>
        </div>
        <div style={{ paddingTop: 20 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            keys="religion"
            label="Religion"
            formId={formId}
            options={RELIGIONS}
            placeholders="Choose from list"
            type="select"
            values={fields}
          />
          </Suspense>
        </div>
        <div style={{ paddingTop: 20 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            keys="sexualPreference"
            label="Sexual Preference"
            formId={formId}
            options={SEXUAL_PREFERENCES}
            placeholders="Choose from list"
            type="select"
            values={fields}
          />
          </Suspense>
        </div>
      </div>
    )
  }
}
